// extracted by mini-css-extract-plugin
export default {"changelogs__container":"Change_changelogs__container__cmnwc","change-type":"Change_change-type__UJeSm"};